import {memo} from "react";
import {cn} from "@/lib/utils";
import SectionTitle from "@/components/common/section-title";

interface AwesomeCardProps {
    children: React.ReactNode;
    className?: string;
    title?: string;
    titleClassName?: string;
    overlayClassName?: string;
}
function AwesomeCard({children, className, title, titleClassName, overlayClassName}: Readonly<AwesomeCardProps>) {
    return (<div className={cn("rounded-xl p-8 bg-bottom shadow text-lg relative", className)}>
        {overlayClassName && <div className={cn('absolute h-full w-full top-0 left-0', overlayClassName)}></div>}
        <div className="relative">
            {title && <SectionTitle title={title} className={cn("mb-4", titleClassName)}/>}
            {children}
        </div>
    </div>)
}

export default memo(AwesomeCard);
